// console.log("updateDisplayBundleCart");
// window.onload = function() {
//     updateDisplayBundleCart();
// };
function updateDisplayBundleCart() {
    // js/common/cart/fetch-cart.js
    var fetchCartBundle = new Promise(async (resolve) => {
      resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
    });
    test();
    async function test() {
      var cart = await fetchCartBundle;
  
      // Créer un objet pour regrouper les line items par leur ID de bundle
      const bundledItems = {};
      let cartCount = 0;
      // Parcourir les line items du panier
      cart.items.forEach((item) => {
        const bundleId = item.properties && item.properties._bundleId;
        
        // Vérifier si la propriété _bundleId existe pour l'item en cours
        if (bundleId) {
          // Vérifier si un objet existe déjà pour cet ID de bundle
          if (bundledItems[bundleId]) {
            // Ajouter l'item à l'objet existant pour cet ID de bundle
            bundledItems[bundleId].items.push(item);
          } else {
            // Créer un nouvel objet pour cet ID de bundle et y ajouter l'item
            bundledItems[bundleId] = {
              bundleId: bundleId,
              items: [item]
            };
          }
        } else {
          cartCount = +item.quantity + cartCount
          // console.log(cartCount);
        }
      });
      // L'objet 'bundledItems' contiendra maintenant des objets distincts regroupant les line items ayant la même valeur dans la propriété '_bundleId'
      // Boucle pour itérer sur les valeurs de bundledItems
      
      Object.values(bundledItems).forEach((bundle) => {  
        cartCount = +bundle.items[0].properties._totalBundle + cartCount
        addPackLineItems(bundle)
      });
      console.log(cartCount);
  
      // Parcourir chaque ligne d'article
      const lineItems = document.querySelectorAll('#mini-cart-form .line-item');
      lineItems.forEach(function(lineItem) {
        // Vérifier si la propriété _isBundleChild est égale à true
        // Masquer la ligne d'article si c'est un élément bundle (isBundleChild = true)
        // console.log(lineItem);
        if (lineItem.dataset.isBundleChild === 'true') {
          lineItem.classList.add('display-none');
        }
      });
      updateNbProducts(cartCount);
    }
  
    
    
  
  // ADD Fake packs line item TEST
  function addPackLineItems(bundle) {
    const parentElementDrawer = document.getElementById('mini-cart-form');
    // const parentElementMainCart = document.querySelector('.line-item-table__list');
    
    var bundleTitle = bundle.items[0].properties._bundleTitle;
    var bundleImg = bundle.items[0].properties._bundleImg;
    var totalBundle = bundle.items[0].properties._totalBundle;
    var variantTitleSelected = bundle.items[0].properties._variantTitleSelected;
    var isBundleVariants = bundle.items[0].properties._isBundleVariants;
    var totalBundlePrice = bundle.items[0].properties._totalBundlePrice.toFixed(2);
    // var bundlePirce = 0;
    // bundle.items.forEach((item) => {
    //   bundlePirce = bundlePirce + item.final_price;
    // });
    bundlePirceFormat = totalBundlePrice / 100;
    bundlePirceFormat = bundlePirceFormat.toFixed(2) + "€ ";
    if (isBundleVariants) {
      var cardHtml = `<line-item id="pack_number_${bundle.bundleId}" class="line-item" >
      <div class="line-item__content-wrapper">
        <a href="/products/zerance-test-4?variant=45238267150609" class="line-item__image-wrapper" tabindex="-1" aria-hidden="true">
          <span class="line-item__loader" hidden>
            <span class="line-item__loader-spinner spinner" hidden><svg focusable="false" width="16" height="16" class="icon icon--spinner   " viewBox="25 25 50 50">
  <circle cx="50" cy="50" r="20" fill="none" stroke="#11545f" stroke-width="6"></circle>
  </svg></span>
            <span class="line-item__loader-mark" hidden><svg focusable="false" width="20" height="20" class="icon icon--check   " viewBox="0 0 32 32">
  <path d="M24.59 8L12.9885 20.6731L7.31806 15.1819L6 16.6956L12.3755 22.8792L13.0805 23.5556L13.7395 22.8309L26 9.43318L24.59 8Z" stroke="currentColor"></path>
  </svg></span>
          </span><img src="${bundleImg}" alt="" width="2000" height="2999" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image"></a><div class="line-item__info">
          <div class="product-item-meta"><div class="product-item-meta__title--price">
              <a href="/products/zerance-test-4?variant=45238267150609" class="product-item-meta__title">${bundleTitle}</a>
              <div style='color: #6ABA95 ; font-weight: 700;' class="price-list price-list--stack"><span class="price ">
              <span class="visually-hidden">Prix de vente</span><span style='color: #6ABA95 '>${bundlePirceFormat}</span></span></div>
              </div>
              
            <div class="product-item-meta__price-list-container text--small">
              <!-- <div class="price-list hidden-tablet-and-up"><span class="price ">
            <span class="visually-hidden">Prix de vente</span><span style='color: #6ABA95 '>${bundlePirceFormat}</span></span></div> --></div>
            <p>${variantTitleSelected}</p>
          </div>
          <div class="product-item-meta__qty--container">
            <p>Quantité: <span>${totalBundle}</span></p>
            <a href="/cart" aria-controls="mini-cart" is="toggle-link" aria-label="Panier" data-no-instant class="line-item__remove-button line-item__remove-button_bundle link text--xxsmall" data-no-instant>Supprimer</a>
          </div>
        </div>
  
        <!-- <div class="line-item__price-list-container text--small hidden-phone"><div style='color: #6ABA95 ; font-weight: 700;' class="price-list price-list--stack"><span class="price ">
            <span class="visually-hidden">Prix de vente</span><span style='color: #6ABA95 '>${bundlePirceFormat}</span></span></div>
        </div> -->
      </div>
      
    </line-item>`
    } else {
      var cardHtml = `<line-item id="pack_number_${bundle.bundleId}" class="line-item" >
      <div class="line-item__content-wrapper">
        <a href="/products/zerance-test-4?variant=45238267150609" class="line-item__image-wrapper" tabindex="-1" aria-hidden="true">
          <span class="line-item__loader" hidden>
            <span class="line-item__loader-spinner spinner" hidden><svg focusable="false" width="16" height="16" class="icon icon--spinner   " viewBox="25 25 50 50">
  <circle cx="50" cy="50" r="20" fill="none" stroke="#11545f" stroke-width="6"></circle>
  </svg></span>
            <span class="line-item__loader-mark" hidden><svg focusable="false" width="20" height="20" class="icon icon--check   " viewBox="0 0 32 32">
  <path d="M24.59 8L12.9885 20.6731L7.31806 15.1819L6 16.6956L12.3755 22.8792L13.0805 23.5556L13.7395 22.8309L26 9.43318L24.59 8Z" stroke="currentColor"></path>
  </svg></span>
          </span><img src="${bundleImg}" alt="" width="2000" height="2999" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image"></a><div class="line-item__info">
          <div class="product-item-meta"><div class="product-item-meta__title--price">
              <a href="/products/zerance-test-4?variant=45238267150609" class="product-item-meta__title">${bundleTitle}</a>
              <div style='color: #6ABA95 ; font-weight: 700;' class="price-list price-list--stack"><span class="price ">
              <span class="visually-hidden">Prix de vente</span><span style='color: #6ABA95 '>${bundlePirceFormat}</span></span></div>
              </div>
              
            <div class="product-item-meta__price-list-container text--small">
              <!-- <div class="price-list hidden-tablet-and-up"><span class="price ">
            <span class="visually-hidden">Prix de vente</span><span style='color: #6ABA95 '>${bundlePirceFormat}</span></span></div> --></div>
          </div>
          <div class="product-item-meta__qty--container">
            <p>Quantité: <span>${totalBundle}</span></p>
            <a href="/cart" aria-controls="mini-cart" is="toggle-link" aria-label="Panier" data-no-instant class="line-item__remove-button line-item__remove-button_bundle link text--xxsmall" data-no-instant>Supprimer</a>
          </div>
        </div>
  
        <!-- <div class="line-item__price-list-container text--small hidden-phone"><div style='color: #6ABA95 ; font-weight: 700;' class="price-list price-list--stack"><span class="price ">
            <span class="visually-hidden">Prix de vente</span><span style='color: #6ABA95 '>${bundlePirceFormat}</span></span></div>
        </div> -->
      </div>
      
    </line-item>`
  
    }
    
    // if (parentElementDrawer){
        parentElementDrawer.insertAdjacentHTML( 'afterbegin', cardHtml );
    // } else if (parentElementMainCart) {
    //     parentElementMainCart.insertAdjacentHTML( 'afterbegin', cardHtml );
    // }
    
    removePackLineItems(bundle.bundleId);
  }
  
  function updateNbProducts(cartCount) {
    const miniCartProductCount = document.querySelector(`.mini-cart_count`);
    const headerProductCount = document.querySelector(`.header__cart-count`);
    // console.log(totalNbProduct);
    if (miniCartProductCount){
        miniCartProductCount.innerHTML = cartCount;
    }
    // console.log(headerProductCount);
    // console.log(totalNbProduct);
    headerProductCount.innerHTML = cartCount;
    // console.log(headerProductCount);
  
  }
  // Remove Fake packs line item AND Remove content of packs by shopify cart API
  function removePackLineItems(packIdSplit) {
    const cartRmovePackButtons = document.querySelectorAll(`#pack_number_${packIdSplit} .line-item__remove-button_bundle`);
     
    cartRmovePackButtons.forEach((cartRmovePackButton) => {
        cartRmovePackButton.addEventListener("click", async (el) => {
            var cart = await fetchCartBundle;
            // now have access to Shopify cart object
            let updates = {};
            cart.items.forEach((item) => {
                if (item.properties != undefined && item.properties._bundleId != undefined) {
                    if (parseInt(item.properties._bundleId) == parseInt(packIdSplit)) {
                        item.quantity = 0;
                        updates[item.key] = 0;
                    }
                }
            });
            
            const cartContent = await (await fetch(`${Shopify.routes.root}cart/update.js`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                updates,
                sections: ["mini-cart"]
              })
            })).json();
  
            document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent
              }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: window.themeVariables.settings.cartType === "drawer"
              }
            }));
            document.querySelector('.icon-mini-cart').click();
            
            
        });
    });
  }
    
   
}

// updateDisplayBundleCartPage();